import React, { useLayoutEffect, useMemo, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { IoChevronBack } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Apis from '../../../../../api';
import MyPass from '../../../../../assets/images/mypass.svg';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import HSButton from '../../../../common/Button';
import LoginActions from '../../../../login/redux/actions';
import { InvestorStatus } from '../../../../login/utils/Status';
import { SETTINGS_PATH } from '../../../settings';
import { KYCInfo, Review } from '../../../settings/fragments/DefaultKYC';
import { ONBOARDING_PATH } from '../../Onbording';
import OnboardingCard from '../common/Card';
import OnboardingRightContainer from '../common/Container';
import { InvestmentPreferencesCompleted } from '../investmentPreferences';
import IndividualKYC, { SkipKYC } from './Manual/IndividualKYC';
import InstitutionalKYC from './Manual/InstitutionalKYC';
import MyInfoModal from './Modal/MyinfoModal';
import SinpassForm from './Signpass';

const NewKYCFlow: React.FC = () => {
    const location = useLocation();
    const kyc = useSelector((state: RootState) => state.user.investor?.kyc);
    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);
    const [type, setType] = useState<string | undefined>(undefined);

    const selectedType = location.state as { selectedType: string };

    useLayoutEffect(() => {
        if (selectedType && selectedType.selectedType) {
            setType(selectedType.selectedType);
        } else if ((kyc && kyc.info) || (kyc?.docs && kyc?.docs.length > 0)) {
            setType('Manual');
        } else {
            setType(window.location.pathname.includes(HEADERMENU_PATH.settings) ? undefined : 'Options');
        }
    }, [kyc, investorType, selectedType]);

    const page = useMemo(() => {
        switch (type) {
            case 'Manual':
                return <ManualKYC />;
            case 'Options':
                return <InvestmentPreferencesCompleted setType={setType} />;
            case 'error':
                return <ErrorOnMyInfo />;
            default:
                return <DefaultOptionCards setType={setType} />;
        }
    }, [type]);

    return (
        <OnboardingRightContainer>
            <div>{page}</div>
        </OnboardingRightContainer>
    );
};

export default NewKYCFlow;

const ManualKYC = () => {
    const navigate = useNavigate();
    const [singPasstype, setType] = useState(false);

    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);
    const type = useSelector((state: RootState) => state.user.investor?.kyc?.info?.type);
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status);

    if (investorType === 'Individual Accredited') {
        if (type && type === 'Myinfo') {
            return (
                <>
                    <Review />
                    {(investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
                        investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails) &&
                        !singPasstype && (
                            <>
                                <OnboardingCard>
                                    <div className="flex justify-center flex-col w-full px-2 pt-3 md:px-8">
                                        <p className="inline-block text-center w-full text-xl title_color">
                                            Complete your KYC with Singpass (
                                            <img
                                                src={MyPass}
                                                alt="myipass"
                                                className="inline-block relative -top-0.5"
                                            />
                                            )
                                        </p>
                                        <p
                                            className="text-center pt-4 w-full md:w-3/4 m-auto"
                                            style={{ color: '#777777' }}
                                        >
                                            This option is applicable for Singapore Citizens and Singapore Permanent
                                            Residents (PRs)
                                        </p>
                                        <MyInfoModal />
                                    </div>
                                </OnboardingCard>
                                <OnboardingCard>
                                    <div className="flex justify-center flex-col w-full px-2 pt-3 md:px-8">
                                        <p className="inline-block text-center w-full text-xl title_color">
                                            Complete Form Manually
                                        </p>
                                        <p
                                            className="text-center pt-4 w-full md:w-3/4 m-auto"
                                            style={{ color: '#777777' }}
                                        >
                                            If you do not have Singpass
                                        </p>
                                        <div className="flex justify-center items-center pt-8 pb-3">
                                            <HSButton
                                                title="START"
                                                type="primary"
                                                onClick={() => {
                                                    if (window.location.pathname.includes(HEADERMENU_PATH.settings)) {
                                                        navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`, {
                                                            state: { selectedType: 'Manual' },
                                                        });
                                                    } else {
                                                        navigate(
                                                            `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`,
                                                            {
                                                                state: { selectedType: 'Manual' },
                                                            },
                                                        );
                                                    }
                                                    setType(true);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </OnboardingCard>
                            </>
                        )}
                    {singPasstype && (
                        <HSButton
                            type="link"
                            title="Back"
                            className="uppercase pl-0 text-base"
                            style={{ color: '#1B3E8C' }}
                            onClick={() => setType(!singPasstype)}
                            icon={<IoChevronBack />}
                        />
                    )}
                    {!singPasstype ? <SinpassForm /> : <IndividualKYC />}
                </>
            );
        }
        return (
            <>
                <KYCInfo />
                <Review />
                {(investorStatus?.kyc === InvestorStatus.PendingKYCResubmission ||
                    investorStatus?.kyc === InvestorStatus.PendingKYCAdditionalDetails) && (
                    <OnboardingCard>
                        <div className="flex justify-center flex-col w-full px-2 pt-3 md:px-8">
                            <p className="inline-block text-center w-full text-xl title_color">
                                Complete your KYC with Singpass (
                                <img src={MyPass} alt="myipass" className="inline-block relative -top-0.5" />)
                            </p>
                            <p className="text-center pt-4 w-full md:w-3/4 m-auto" style={{ color: '#777777' }}>
                                This option is applicable for Singapore Citizens and Singapore Permanent Residents (PRs)
                            </p>
                            <MyInfoModal />
                        </div>
                    </OnboardingCard>
                )}
                <IndividualKYC />
            </>
        );
    }
    if (investorType === 'Institutional' || investorType === 'Corporate Accredited') {
        return (
            <>
                <KYCInfo />
                <Review />
                {investorStatus?.kyc === InvestorStatus.PendingKYCResubmission && (
                    <OnboardingCard>
                        <div className="flex justify-center flex-col w-full px-2 pt-3 md:px-8">
                            <p className="inline-block text-center w-full text-xl title_color">
                                Complete your KYC with Singpass (
                                <img src={MyPass} alt="myipass" className="inline-block relative -top-0.5" />)
                            </p>
                            <p className="text-center pt-4 w-full md:w-3/4 m-auto" style={{ color: '#777777' }}>
                                This option is applicable for Singapore Citizens and Singapore Permanent Residents (PRs)
                            </p>
                            <MyInfoModal />
                        </div>
                    </OnboardingCard>
                )}
                <InstitutionalKYC />
            </>
        );
    }
    return null;
};

type DefaultProps = {
    setType: (s: string) => void;
};

export const DefaultOptionCards: React.FC<DefaultProps> = ({ setType }) => {
    const navigate = useNavigate();
    const kycType = useSelector((state: RootState) => state.user.investor?.investorType);

    return (
        <div>
            <p className="text-color-404040  text-center text-xl">Choose your preferred method to complete KYC</p>
            <div className="pt-6">
                {kycType === 'Individual Accredited' && (
                    <OnboardingCard>
                        <div className="flex justify-center flex-col w-full px-2 pt-3 md:px-8">
                            <p className="inline-block text-center w-full text-xl title_color">
                                Complete your KYC with Singpass (
                                <img src={MyPass} alt="myipass" className="inline-block relative -top-0.5" />)
                            </p>
                            <p className="text-center pt-4 w-full md:w-3/4 m-auto" style={{ color: '#777777' }}>
                                This option is applicable for Singapore Citizens and Singapore Permanent Residents (PRs)
                            </p>
                            <MyInfoModal />
                        </div>
                    </OnboardingCard>
                )}
                <OnboardingCard>
                    <div className="flex justify-center flex-col w-full px-2 pt-3 md:px-8">
                        <p className="inline-block text-center w-full text-xl title_color">Complete Form Manually</p>
                        <p className="text-center pt-4 w-full md:w-3/4 m-auto" style={{ color: '#777777' }}>
                            If you do not have Singpass
                        </p>
                        <div className="flex justify-center items-center pt-8 pb-3">
                            <HSButton
                                title="START"
                                type="primary"
                                onClick={() => {
                                    if (window.location.pathname.includes(HEADERMENU_PATH.settings)) {
                                        navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`, {
                                            state: { selectedType: 'Manual' },
                                        });
                                    } else {
                                        navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, {
                                            state: { selectedType: 'Manual' },
                                        });
                                    }
                                    setType('Manual');
                                }}
                            />
                        </div>
                    </div>
                </OnboardingCard>
                <div className="flex justify-center pt-4">
                    <SkipKYC disabled={false} />
                </div>
            </div>
        </div>
    );
};

export const ErrorOnMyInfo = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const investorUUID = useSelector((state: RootState) => state.user.uuid);

    const [loader, setLoader] = useState(false);

    const manualKYC = () => {
        if (window.location.pathname.includes(HEADERMENU_PATH.settings)) {
            navigate(`${HEADERMENU_PATH.settings}/${SETTINGS_PATH.KYC}`, { state: { selectedType: 'Manual' } });
        } else {
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, { state: { selectedType: 'Manual' } });
        }
    };

    const onClickTry = () => {
        let type: 'setting' | 'onboarding' | undefined = undefined;
        if (window.location.pathname.includes(HEADERMENU_PATH.settings)) {
            type = 'setting';
        }
        if (window.location.pathname.includes(HEADERMENU_PATH.onboarding)) {
            type = 'onboarding';
        }
        dispatch(LoginActions.updateMyinfo(type));
        if (investorUUID) {
            setLoader(true);
            Apis.redirectToMyinfo(investorUUID, false)
                .then(({ data }) => {
                    window.location.href = data;
                })
                .catch(() => {
                    setLoader(false);
                });
        }
    };
    return (
        <div className={`my-2 mt-10`}>
            <div
                className="p-4 relative bg-white rounded-md md:p-4 cursor-pointer"
                style={{ boxShadow: `5px 5px 10px rgba(0, 0, 0, 0.1)` }}
            >
                <div className="h-2 w-full absolute left-0 top-0 rounded-t-md" style={{ backgroundColor: '#FF0000' }} />
                <div className="flex pt-3">
                    <div className="border-l-8 hidden md:hidden" style={{ borderColor: '#c49a6d' }} />
                    <div className="flex w-full">
                        <div
                            className={`w-10 h-10 ml-0 mr-4 md:ml-2  rounded-full hidden md:flex justify-center items-center bg-red-200`}
                        >
                            <div className="w-8 h-8 rounded-full flex justify-center items-center bg-red-500">
                                <IoMdClose size="1.4rem" color="#fff" />
                            </div>
                        </div>
                        <div className="w-full" style={{ width: '94%' }}>
                            <p className="text-sm font-bold WorkSans md:text-sm text-color-404040">Error</p>
                            <label>Your information could not be retrieved from the My info portal.</label>
                            <div className="flex mt-4 flex-col md:flex-row">
                                <HSButton
                                    title="TRY AGAIN"
                                    className="onboarding_btn mt-2"
                                    loading={loader}
                                    onClick={onClickTry}
                                />
                                <HSButton
                                    title="Complete form manually"
                                    className="onboarding_btn light_btn ml-2 mt-2"
                                    light
                                    onClick={manualKYC}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
